import { AnchorTag } from 'components/core/AnchorTag'
import Popover from 'components/core/Popover'
import pluralize from 'pluralize'
import { ChatMessageAttachment } from './ChatMessageAttachment'

type ChatMessageAttachmentsProps = {
    align: 'start' | 'end'
    attachments: { filename: string; onDownload: () => Promise<void> }[]
}

export const ChatMessageAttachments = ({
    align,
    attachments,
}: ChatMessageAttachmentsProps) => {
    return (
        <Popover
            align={align}
            sideOffset={8}
            trigger={
                <AnchorTag underline color="primary" variant="caption">
                    {pluralize('attachments', attachments.length, true)}
                </AnchorTag>
            }
        >
            {(onClose) =>
                attachments.map((a, idx) => {
                    return (
                        <ChatMessageAttachment
                            key={idx}
                            filename={a.filename}
                            onDownload={a.onDownload}
                            onDownloadSuccess={onClose}
                        />
                    )
                })
            }
        </Popover>
    )
}
